module.exports = __webpack_public_path__ + "img/yanzheng.963be293.png";